import React from "react";
import { StyledSpinner } from "./style";
import { Props } from "./types";

const Spinner = (props: Props) => {
  return <StyledSpinner {...props} />;
};

export default Spinner;
